import { useState, ReactNode } from 'react';
import { Outlet } from 'react-router-dom';
import { Sidebar } from './sidebar';
import { Header } from './header';
import { BottomNav } from './bottom-nav';
import { MobileMenu } from './mobile-menu';
import { usePlatform } from '@/hooks/use-platform';

interface AppShellProps {
  demoBanner?: ReactNode;
}

export function AppShell({ demoBanner }: AppShellProps = {}) {
  const { isMobile = false } = usePlatform();
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Demo banner (if provided) */}
      {demoBanner}
      
      {/* Desktop sidebar */}
      {!isMobile && <Sidebar />}

      {/* Mobile menu drawer */}
      {isMobile && <MobileMenu isOpen={isMenuOpen} onClose={() => setIsMenuOpen(false)} />}

      {/* Main content area */}
      <div className={isMobile ? 'pb-16' : 'lg:pl-64'}>
        <Header onMenuClick={() => setIsMenuOpen(true)} />
        <main className="p-4 lg:p-6">
          <Outlet />
        </main>
      </div>

      {/* Mobile bottom navigation */}
      {isMobile && <BottomNav />}
    </div>
  );
}
